import { useEffect } from "react";

import { createPortal } from "react-dom";

import { useIntroLogoStore } from "@storage/global/useIntroLogoStore";

import { DELAY_TIME_5000 } from "@configs/constants";
import { ENV_CONFIG } from "@configs/env";

/** Display intro logo after user sign in. Default: available on production */
export const DisplayIntroLogo = () => {
	const { isVisible, hide } = useIntroLogoStore();
	const isShow = ENV_CONFIG.SHOW_INTRO_LOGO === "true";

	useEffect(() => {
		if (!isVisible) return;

		const timer = setTimeout(() => {
			hide();
		}, DELAY_TIME_5000);

		return () => clearTimeout(timer);
	}, [isVisible]);

	if (!isShow || !isVisible) return null;

	const content = (
		<div className="absolute top-0 z-max w-full">
			<div className="relative h-screen overflow-hidden">
				<div
					className={`absolute top-1/2 left-1/2 h-[calc(100vw*(562/1000))] min-h-full w-[calc(100vh*(1000/562))]
						min-w-full -translate-x-1/2 -translate-y-1/2`}
				>
					<video autoPlay muted playsInline className="absolute top-0 left-0 h-full w-full">
						<source src={`${ENV_CONFIG.BASE_BUCKET_URL}/LogoAnimation.mp4`} type="video/mp4" />
					</video>
				</div>
			</div>
		</div>
	);

	return createPortal(content, document.getElementById("root") as HTMLElement);
};
